module.exports = __webpack_public_path__ + "img/no-product-empty-state.5df19b05.svg";